export enum DriverFinancialEnum {
  NewInvoice = 'New invoice',
  Unpaid = 'Unpaid',
  Paid = 'Paid',
}
